import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Treebeard, decorators } from 'react-treebeard';

import {
  NitroHeading,
  NitroPanel,
  NitroNavBar,
  NitroLoading,
  NitroTextField,
} from 'nitro-components';

import { SelectField, MenuItem, AutoComplete } from 'material-ui';
import { MuiThemeProvider, getMuiTheme } from 'material-ui/styles';
import { colorPalette } from '@src/themes/theme-material-ui';
import { debounce, uniqBy } from 'lodash';

import AdminAPI from '@src/api/AdminApi';
import * as filters from './filter';
import { TreeHeader } from './treecustom';

const autoCompleteTheme = getMuiTheme({
  textField: {
    disabledTextColor: '#bbb',
    borderColor: '#bbb',
    focusColor: colorPalette.colorSecondary,
  },
});

const style = {
  tree: {
    base: {
      listStyle: 'none',
      backgroundColor: '#fff',
      margin: 0,
      padding: 0,
      color: '#222',
      fontFamily: 'noto-sans-regular,sans-serif',
      fontSize: '14px',
    },
    node: {
      base: {
        position: 'relative',
      },
      link: {
        cursor: 'pointer',
        position: 'relative',
        padding: '0px 5px',
        display: 'block',
      },
      activeLink: {
        background: '#ccc',
        color: '#222',
      },
      toggle: {
        base: {
          position: 'relative',
          display: 'inline-block',
          verticalAlign: 'top',
          marginLeft: '-5px',
          height: '24px',
          width: '24px',
        },
        wrapper: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          margin: '-7px 0 0 -7px',
          height: '14px',
        },
        height: 12,
        width: 12,
        arrow: {
          fill: '#222',
          strokeWidth: 0,
        },
      },
      header: {
        base: {
          display: 'inline-block',
          verticalAlign: 'top',
          color: '#222',
        },
        connector: {
          width: '2px',
          height: '12px',
          borderLeft: 'solid 2px black',
          borderBottom: 'solid 2px black',
          position: 'absolute',
          top: '0px',
          left: '-21px',
        },
        title: {
          lineHeight: '24px',
          verticalAlign: 'middle',
        },
      },
      subtree: {
        listStyle: 'none',
        paddingLeft: '19px',
      },
      loading: {
        color: '#E2C089',
      },
    },
  },
};

const childFormatter = srcArr => {
  return srcArr.map(cc => {
    let base = {
      name: `${cc.Name} - (${cc.Code})`,
    };

    if (cc.Children && cc.Children.length > 0) {
      base = Object.assign(base, {
        children: childFormatter(cc.Children),
      });
    }

    return base;
  });
};

decorators.Header = TreeHeader;

class CompanyHierarchy extends Component {
  state = {
    isBizEntityLoaded: false,
    bizEntityDataSource: [],
    bizEntityKey: '',
    businessEntityId: '',
    employerDataSource: [],
    bizEntity: undefined,
    companyHierarchyData: undefined,
    companyCodeSelection: undefined,
  };

  constructor(props) {
    super(props);
    this.baseHierarchyData = [];
  }

  componentDidMount = () => {
    this.getBizEntities();
  };

  onToggle = (node, toggled) => {
    const { cursor } = this.state;
    if (cursor) this.state.cursor.active = false;
    node.active = true;
    if (node.children) node.toggled = toggled;
    this.setState({
      cursor: node,
    });
  };

  goBack = () => {
    const { router } = this.context;
    router.goBack();
  };

  getBizEntities = () => {
    AdminAPI.getBusinessEntities()
      .then(data => {
        this.setbizEntOpts(data);
      })
      .catch(err => err);
  };

  setbizEntOpts = bizEntOpts => {
    this.setState({
      bizEntityDataSource: bizEntOpts,
      isBizEntityLoaded: true,
    });
  };

  getEmployers = (businessEntityId, searchText) =>
    AdminAPI.getEmployer(
      businessEntityId,
      this.state.bizEntity.CountryCode,
      searchText
    )
      .then(data => {
        if (data.length === 1) {
        }
        this.setState({
          employerDataSource: data,
        });
      })
      .catch(err => {
        throw err;
      });

  setBizEntityKey = bizEntKey => {
    const { bizEntityDataSource } = this.state;
    const bizEnt = bizEntityDataSource.find(x => x.EntityKey === bizEntKey);
    this.setState({
      bizEntityKey: bizEntKey,
      bizEntity: bizEnt,
      businessEntityId: bizEnt.Id,
    });

    this.resetTreeView();
  };

  setCompanyCode = companyCode => {
    this.setState({
      companyCodeSelection: companyCode,
    });
  };

  onFilterKeyUp = e => {
    const filterText = e.target.value.trim();
    if (!filterText) {
      return this.setState({
        companyHierarchyData: this.baseHierarchyData,
      });
    }
    var filtered = filters.filterTree(this.baseHierarchyData, filterText);
    filtered = filters.expandFilteredNodes(filtered, filterText);

    console.log('filtered data', filtered);
    this.setState({
      companyHierarchyData: filtered,
    });
  };

  resetTreeView = () => {
    this.baseHierarchyData = [];
    this.refAutoComplete.setState({
      searchText: '',
    });
    this.setState({
      companyCodeSelection: undefined,
      companyHierarchyData: undefined,
      employerDataSource: [],
    });
  };

  getCompanyHierarchy = companyCode => {
    const { bizEntity } = this.state;
    this.setState({
      companyHierarchyData: undefined,
    });
    AdminAPI.getCompanyHierarchy(
      bizEntity.Id,
      bizEntity.CountryCode,
      companyCode
    )
      .then(data => {
        const hrcData = childFormatter(data)[0];
        hrcData.toggled = true;

        this.baseHierarchyData = hrcData;
        this.setState({
          companyHierarchyData: hrcData,
        });
      })
      .catch(err => console.error(err));
  };

  render() {
    const {
      isBizEntityLoaded,
      bizEntityDataSource,
      bizEntityKey,
      bizEntity,
      companyCodeSelection,
      companyHierarchyData,
      businessEntityId,
      employerDataSource,
    } = this.state;

    if (!isBizEntityLoaded) return <NitroLoading center />;

    const filterKeyUpDebounce = debounce(this.onFilterKeyUp, 800);

    const formattedEmpDS = employerDataSource
      ? employerDataSource.map(employer => ({
          ...employer,
          displayName: `${employer.CompanyName} (${employer.CompanyCode})`,
        }))
      : [];

    const buildBizEntMenuItem = bizEntityDataSource => {
      if (!bizEntityDataSource) return null;
      return bizEntityDataSource.map((ea, idx) => (
        <MenuItem
          key={`biz_ent${idx}`}
          value={ea.EntityKey}
          primaryText={`${ea.Name} - ${ea.CountryCode.toUpperCase()}`}
        />
      ));
    };

    const renderTree = () => {
      if (!companyHierarchyData || companyHierarchyData.length <= 0)
        return <NitroLoading />;

      return (
        <Treebeard
          data={companyHierarchyData}
          onToggle={this.onToggle}
          style={style}
        />
      );
    };

    return (
      <div>
        <NitroNavBar label="Back" action={this.goBack} header />
        <NitroPanel>
          <NitroHeading
            label="Company Hierarchy View"
            header
            variant="secondary"
          />

          <SelectField
            floatingLabelText="Business Entity"
            fullWidth
            value={bizEntityKey}
            // lock be selector if in edit mode, e.g. userId exist
            onChange={(event, key, payload) => {
              this.setBizEntityKey(payload);
            }}
          >
            {buildBizEntMenuItem(bizEntityDataSource)}
          </SelectField>

          <MuiThemeProvider muiTheme={autoCompleteTheme}>
            <AutoComplete
              floatingLabelText="Employer"
              disabled={!businessEntityId}
              fullWidth
              dataSourceConfig={{
                text: 'displayName',
                value: 'CompanyCode',
              }}
              ref={autoc => (this.refAutoComplete = autoc)}
              maxSearchResults={100}
              filter={AutoComplete.noFilter}
              openOnFocus
              dataSource={formattedEmpDS}
              onUpdateInput={debounce((searchText, ds, params) => {
                if (params && params.source === 'click') return;
                if (searchText.length > 1)
                  this.getEmployers(businessEntityId, searchText);
              }, 500)}
              onNewRequest={(chosenRequest, index) => {
                this.setCompanyCode(chosenRequest);
                this.getCompanyHierarchy(chosenRequest.CompanyCode);
                // console.log(chosenRequest, index)
              }}
              textFieldStyle={{
                color: '#bbb',
              }}
            />
          </MuiThemeProvider>
        </NitroPanel>

        {bizEntity && companyCodeSelection && (
          <NitroPanel>
            <NitroHeading
              label={`Company Hierarchy of ${
                companyCodeSelection.CompanyName
              } (${companyCodeSelection.CompanyCode}) in ${
                bizEntity.Name
              } ${bizEntity.CountryCode.toUpperCase()}`}
            />
            <NitroTextField
              floatingLabelText="Filter by Name / Code"
              onKeyUp={e => {
                e.persist();
                filterKeyUpDebounce(e);
              }}
              ref={input => (this.refFilterText = input)}
            />
            {renderTree()}
          </NitroPanel>
        )}
      </div>
    );
  }
}

CompanyHierarchy.contextTypes = {
  router: PropTypes.object,
};

export default CompanyHierarchy;



// WEBPACK FOOTER //
// ./src/features/company-hierarchy/index.js